import React from "react";
import { connect } from "react-redux";

import { IAppState } from "../../state/Store";
import { initialiseImports } from "../../state/files/Imports";
import { FileUploadState } from "../../state/files/Folders";
import ProgressBar from "../progressBar/ProgressBar";
import File from "../../types/files/File";

import loader from "../../resources/loadGear.gif";
import "./Status.scss";

interface StatusProps {
    uploads?: FileUploadState[];
    imports?: File[];

    initialiseImports: () => Promise<void>;
}

class Status extends React.Component<StatusProps> {
    async componentDidMount() {
        this.props.initialiseImports();
    }

    render(): React.ReactNode {
        return (
            <>
                <div
                    className={`status-uploads ${
                        this.props.uploads?.length || this.props.imports?.length
                            ? "on"
                            : ""
                    }`}>
                    <div className="upload-text">
                        Current Status Items:{" "}
                        {(this.props.uploads?.length ?? 0) +
                            (this.props.imports?.length ?? 0)}
                    </div>
                    <img
                        className="upload-img"
                        src={loader}
                        alt="Loading..."
                    />
                </div>
                <div
                    className={`status-upload-slide ${
                        this.props.uploads?.length || this.props.imports?.length
                            ? "on"
                            : ""
                    }`}>
                    <div className="upload-display">
                        {this.props.uploads?.map((item, index) => (
                            <div
                                key={index}
                                className="single-upload">
                                <div className="name">{item.name}</div>
                                <ProgressBar
                                    className="status-container"
                                    progress={item.progress}
                                />
                            </div>
                        ))}
                        {this.props.imports?.map((item, index) => (
                            <div
                                key={index}
                                className="single-upload">
                                <div className="name">{item.name}</div>
                                <div className="status-container text">
                                    {item.message}
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    const { folders, imports } = state.db;
    return {
        uploads: folders.uploads,
        imports: imports.imports,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        initialiseImports: () => dispatch(initialiseImports()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Status);
